var t = function t() {
  var t = "";
  var o = "0123456789abcdef";
  for (var a = 0; a < 36; a += 1) t += 8 === a || 13 === a || 18 === a || 23 === a ? "-" : 14 === a ? "4" : 19 === a ? o[4 * Math.random() | 8] : o[Math.floor(16 * Math.random())];
  return t;
};
export { t as default };